module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_c('h1', [_vm._v("Demo for downloading/display PDF base64 string in IE, Chrome, Safari")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-455a91b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/PreviewPDF.vue
// module id = 682
// module chunks = 2